<template>
  <div>
    <h1 style="color: white">Fratello Sole e Sorella Luna</h1>
    <p>Il Cantico delle Creature di San Francesco d'Assisi - Un viaggio nella spiritualità francescana</p>
  </div>
  <div class="section">
    <div class="section-content">
      <h2>Testo cantico</h2>
      <p>Il Cantico delle Creature di San Francesco</p>
    </div>

    <div class="session-details">
      <span class="session-title"> Testo Cantico </span>
      <p>
        Il Cantico delle Creature è uno dei testi più belli della letteratura italiana. In esso, San Francesco loda Dio attraverso le sue creature: il sole, la luna, le stelle, l'acqua, il fuoco e la terra, riconoscendo in ognuna la bellezza del Creatore.
      </p>
      <router-link class="button" to="/testo-cantico" style="margin: 10px auto; display: inline-block">Avanti <i class="fa fa-arrow-right"></i> </router-link>
    </div>

    <div class="pic-container" >
      <img src="~\src\assets\Copertina_Cantico.jpeg" alt="Testo Cantico">
    </div>
  </div>

  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>

  <div class="section is-inverted">
    <div class="section-content">
      <h2>Vita</h2>
      <p>La vita di San Francesco d'Assisi</p>
    </div>

    <div class="session-details">
      <span class="session-title"> Vita </span>
      <p>
        La vita di San Francesco è un esempio di conversione radicale, dall'agio della giovinezza alla povertà evangelica. La sua esistenza fu dedicata a Cristo, ai poveri e al creato, lasciando un'eredità spirituale che ancora oggi ispira milioni di persone.
      </p>
      <router-link class="button" to="/vita" style="margin: 10px auto; display: inline-block">Avanti <i class="fa fa-arrow-right"></i> </router-link>
    </div>

    <div class="pic-container">
      <img src="~\src\assets\Copertina_Vita.jpg" alt="Vita">
    </div>
  </div>

  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>

  <div class="section">
    <div class="section-content">
      <h2>Natura</h2>
      <p>Il creato come dono divino e fratellanza universale</p>
    </div>

    <div class="session-details">
      <span class="session-title"> Natura </span>
      <p>
        San Francesco vede la natura come sorella e fratello, riconoscendo in ogni creatura un riflesso della gloria divina. Il Cantico delle Creature celebra l'armonia tra l'uomo e il creato, invitando al rispetto e alla cura della casa comune.
      </p>
      <router-link class="button" to="/natura" style="margin: 10px auto; display: inline-block">Avanti <i class="fa fa-arrow-right"></i> </router-link>
    </div>

    <div class="pic-container">
      <img src="~\src\assets\Copertina_Natura.jpg" alt="Natura">
    </div>
  </div>

  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>

  <div class="section is-inverted">
    <div class="section-content">
      <h2>Limiti</h2>
      <p>I limiti dell'uomo e la consapevolezza della propria fragilità</p>
    </div>

    <div class="session-details">
      <span class="session-title"> Limiti </span>
      <p>
        San Francesco riconosce i limiti dell'esistenza umana, abbracciando l'umiltà e la fragilità come parte del cammino spirituale. Accettare i propri limiti significa riconoscere la dipendenza da Dio e dalla creazione.
      </p>
      <router-link class="button" to="/limiti" style="margin: 10px auto; display: inline-block">Avanti <i class="fa fa-arrow-right"></i> </router-link>
    </div>

    <div class="pic-container">
      <img src="~\src\assets\Copertina_Limiti.jpg" alt="Limiti">
    </div>
  </div>

  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>

  <div class="section">
    <div class="section-content">
      <h2>Misericordia</h2>
      <p>L'amore compassionevole e il perdono divino</p>
    </div>

    <div class="session-details">
      <span class="session-title"> Misericordia </span>
      <p>
        La misericordia è al centro della spiritualità francescana. È l'amore che perdona, che accoglie e che trasforma. San Francesco invita a vivere con compassione verso tutte le creature e a sperimentare la misericordia infinita di Dio.
      </p>
      <router-link class="button" to="/misericordia" style="margin: 10px auto; display: inline-block">Avanti <i class="fa fa-arrow-right"></i> </router-link>
    </div>

    <div class="pic-container">
      <img src="~\src\assets\Copertina_Misericordia.jpg" alt="Misericordia">
    </div>
  </div>
  <div style="margin-top: 200px; height: 1px;"></div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style>
.section {
  display: grid;
  margin: 60px auto;
  max-width: 800px;
  height: 200px;
  overflow: hidden;
  border-radius: 5px;
  background: #181a1c;
  transition: transform 0.3s, height 0.3s;
  grid-template-columns: 1fr 1fr;
}

.arrow-spacer {
  margin: 40px 0;
}

.section:hover {
  transform: scale(1.05);
  height: 300px;
}

.session-details {
  opacity: 0;
  position: absolute;
}

.section:hover .session-details {
  opacity: 1;
  position: relative;
  padding: 20px;
  text-align: left;
  width: unset;
}

.session-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color: white;
}

.section:hover .section-content {
  opacity: 0;
  position: absolute;
}

.section-content {
  padding: 20px;
  color: white;
  text-align: center;
  width: 100%;
  margin: auto 0;
}

.section img {
  height: 100%;
  margin: auto;
}

.section.is-inverted {
  background: #181a1c;
}
.section.is-inverted .pic-container {
  order: -1;
  transform: unset;
}

.pic-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  place-items: center;
}

.pic-container img {
  position: relative;
  margin: auto;
}

p {
  color: #9f9d9d;
}

.biznes ul{
  color: #9f9d9d;
  padding: 0 20px;
}

.biznes li::marker{
  color: #9f9d9d;
  margin: 0;
}

.biznes li{
  margin-right: 5px;
}

.faq-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #1e1e1e;
  color: #ffffff;
  border-radius: 8px;
}

.faq-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.faq-item {
  flex: 1 1 calc(50% - 20px);
  border: 1px solid #333;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #2c2c2c;
  transition: height 0.3s;
}

.faq-item.open {
  height: auto;
}

.question {
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question:hover {
  background-color: #3d3d3d;
}

.answer {
  padding: 10px;
  border-top: 1px solid #333;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}
</style>
